export class DeliveryType {
	public id: number;
	public name: string;
	public sortOrder: number;

	constructor(deliveryType?: DeliveryType) {
		Object.assign(this, deliveryType);
	}
}
